import * as querystring from "querystring";
import * as config from "../config";
import * as Auth from "./Auth";
import { saveAs } from "file-saver";

export const handleDownload = (url, filename) => {
  saveAs(url, filename);
};

const get = (uri, data, successCallback, failureCallback) => {
  const searchParams = new URLSearchParams(window.location.search);

  return fetch(config.apiUrl + uri + "?" + querystring.stringify(data), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: Auth.getToken() || searchParams.get("token"),
    },
  })
    .then((response) => {
      const token = response.headers.get("tokenJWT");
      if (response.status === 401) {
        Auth.removeToken();
        window.location.href = "/login";
      } else {
        if (token && token !== "") {
          Auth.setToken(token);
        }
        return response.json().then((json) => {
          if (successCallback) return successCallback(json);
        });
      }
    })
    .catch((err) => {
      console.log(uri);
      console.log(err);
      if (failureCallback) return failureCallback(err);
    });
};

const post = (uri, data, successCallback, failureCallback) => {
  return fetch(config.apiUrl + uri, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: Auth.getToken(),
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      const token = response.headers.get("tokenJWT");

      if (response.status === 401) {
        Auth.removeToken();
        window.location.href = "/login";
      } else if (response.status >= 400) {
        if (failureCallback) return failureCallback(response);
      } else {
        if (token && token !== "") {
          Auth.setToken(token);
        }
        return response
          .json()
          .then((json) => {
            if (successCallback) return successCallback(json);
          })
          .catch(() => {
            if (successCallback) return successCallback();
          });
      }
    })
    .catch((err) => {
      console.log(uri);
      console.log(err);
      if (failureCallback) return failureCallback(err);
    });
};

export default { get, post };
